// hello.atlassian.net cloud id
var HELLO_CLOUD_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';

// spike page https://hello.atlassian.net/wiki/spaces/~7120208ef57ce4d614485e876489301a16b906/pages/5626233808
var TEST_PAGE_ID = '5626233808';
export var getPageId = function getPageId() {
  var _window$location$href, _window$location$href2, _window$location$path;
  return (
    // eslint-disable-next-line require-unicode-regexp
    ((_window$location$href = window.location.href.match(/pageId=(\d+)/)) === null || _window$location$href === void 0 ? void 0 : _window$location$href[1]) || ( // eslint-disable-next-line require-unicode-regexp
    (_window$location$href2 = window.location.href.match(/pages\/edit-v2\/(\d+)/)) === null || _window$location$href2 === void 0 ? void 0 : _window$location$href2[1]) || ( // eslint-disable-next-line require-unicode-regexp
    (_window$location$path = window.location.pathname.match(/pages\/(\d+)/)) === null || _window$location$path === void 0 ? void 0 : _window$location$path[1]) ||
    // view page or live doc
    TEST_PAGE_ID
  );
};
/**
 * This by no means is a stable way to get the cloud id, but it works for now.
 * We should switch passing the cloud id from Confluence to a Editor plugin,
 * for instance the user preferences plugin would have a seperate place for user and cloud info
 * @returns the cloud id from the initial state
 */
export var getCloudId = function getCloudId() {
  var _INITIAL_STATE__;
  return ((_INITIAL_STATE__ = window.__INITIAL_STATE__) === null || _INITIAL_STATE__ === void 0 || (_INITIAL_STATE__ = _INITIAL_STATE__.meta) === null || _INITIAL_STATE__ === void 0 ? void 0 : _INITIAL_STATE__['cloud-id']) || HELLO_CLOUD_ID;
};